// @flow

import React, { Component } from 'react';
import { Breakpoint } from 'react-socks';
import { Link, Redirect } from "react-router-dom";
import { Container, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import Lottie from 'react-lottie';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content'
import { FaCheckCircle } from "react-icons/fa";
import { RiEBike2Line, RiShoppingBagLine } from "react-icons/ri";
import Masonry from 'react-masonry-css'
import differenceInHours from 'date-fns/differenceInHours';
import * as animationData from '../assets/loading.json'
import * as animationData404 from '../assets/404.json'
import { withTranslation } from 'react-i18next'

import '../styles/Restaurant.scss'
import { updateRestoInfo, updateType, resetCart, applyDiscount, applyCoupon, pickedOrderType, setDiscountSettings } from '../actions/cartAction';
import { updateRestoSettings, updateDeliverySchedule, updateOrderSchedule, updateDeliverySettings, updateTakeawaySettings, updateMenuSettings, setLanguage } from '../actions/settingsAction';
import { flushRecommendations, incrementRecommendationCount, setHasRefused, setRecommendation1, setRecommendation2 } from '../actions/recommendationAction';
import { updateColors } from '../actions/colorsAction'

import ProductDetail from './ProductDetail'
import $ from "jquery"
import dayjs from 'dayjs'
import { getAvailabilityPeriod, isProductAvailable } from '../utils/availabilityUtils'
import { isPublicHolidayToday } from '../utils/publicHolidays'

import { getBusinessTypes, getOrderType, parseSchedule, computeDiscount, convertFirebaseUrlToCustomDomain, formatCurrency } from './Utils'
import ProductCartRow from './ProductCartRow'
import ProductRecommendation from './ProductRecommendation'
import { CartType, ProductType } from '../flowObjectType'
import { firestore, analytics } from '../services/firebase'
import { getSecondaryFirestore } from '../services/firebaseSecondary'
import FooterBar from './FooterBar'
import LanguageSelector from './LanguageSelector'
import { getTrans, getActiveLanguages, DEFAULT_LANG } from '../utils/translations'

import spicy1 from "../assets/classification/spicy1.webp"
import spicy2 from "../assets/classification/spicy2.webp"
import spicy3 from "../assets/classification/spicy3.webp"
import homemade from "../assets/classification/homemade.webp"
import vegetarian from "../assets/classification/vegetarian.png"
import recommended from "../assets/classification/recommended.png"
import halal from "../assets/classification/halal.webp"

const ImageData = {}
ImageData['vegetarian'] = vegetarian
ImageData['recommended'] = recommended
ImageData['halal'] = halal
ImageData['homemade'] = homemade
ImageData['spicy1'] = spicy1
ImageData['spicy2'] = spicy2
ImageData['spicy3'] = spicy3


// color
// text black
// background #F1F1F1
// blue #00CCBB
// yellow #FDC151
// red #FF4B4B

const breakpointColumnsObj = {
  default: 4,
  1100: 3,
  700: 2,
  500: 2
};

type Props = {
  match: Object,
  cart: CartType,
  settings: Object,
  updateType: Function,
  updateRestoInfo: Function,
  updateRestoSettings: Function,
  updateDeliverySchedule: Function,
  updateOrderSchedule: Function,
  resetCart: Function,
  updateTakeawaySettings: Function,
  updateDeliverySettings: Function,
  flushRecommendation: Function,
  recommendation: Object,
  updateColors: Function,
  updateMenuSettings: Function,
  setLanguage: Function,
  t: Function
}

type State = {
  canOrder: boolean,
  settings: Object,
  informations: Object,
  showProductDetail: boolean,
  showRecommendation: boolean,
  selectedRecommendation: Object,
  restaurant: Object,
  sections: Array<Object>,
  selectedProduct: ?ProductType,
  invalidQrCode: boolean,
  selectedCategoryIdx: number,
  selectedIdx: ?number,
  orderType: ?number,
  table: ?string,
  redirectToCart: boolean,
}

function goToAnchor(event: Object, id: string) {
  const productPositionY = $(`#section-${id}`).offset().top - 65
  // $(event.target).css('backgroundColor', 'white')
  $("html, body").animate({ scrollTop: productPositionY }, 500);
  event.preventDefault();
}

let savedSticky = 0
function handleStickyHeader(header) {
  let sticky = header[0].offsetTop
  if (header.hasClass("sticky")) {
    sticky = savedSticky
  }

  if (window.pageYOffset > sticky) {
    savedSticky = sticky
    header.addClass("sticky");
  } else {
    header.removeClass("sticky");
  }
}
function handleActiveSection(header) {

  const topMenuHeight = header.outerHeight() + 10
  const menuItems = header.find(".options-btn")
  const scrollItems = menuItems.map(function () {
    var item = $($(this).attr("href"));
    if (item.length) { return item; }
    return null
  });

  var fromTop = window.scrollY + topMenuHeight;
  var lastId;
  // Get id of current scroll item

  var cur = scrollItems.map(function () {
    if ($(this).offset().top < fromTop)
      return this;
    return null
  });
  // Get the id of the current element
  cur = cur[cur.length - 1];
  var id = cur && cur.length ? cur[0].id : "";

  if (lastId !== id) {
    lastId = id;
    // Set/remove active class
    if (id === "") return
    menuItems.removeClass("selected")
    const selectedItem = menuItems.filter("[href='#" + id + "']")
    selectedItem.addClass("selected");
    if (selectedItem[0]) {
      selectedItem[0].scrollIntoView({
        behavior: 'instant',
      });
    }
  }

}

const CategoryRow = (props) => props.category.displayApp === false ?
  (<></>)
  : (
    <>
      <a href={`#section-${props.category.id}`} className={`options-btn ${props.selected ? 'selected' : ''}`} onClick={(event) => { goToAnchor(event, props.category.id) }}>
        {getTrans(props.category, 'name', props.lang)}
      </a>
    </>
  )

const CategoryLogo = (props) => (
  <>
    <a href={`#section-${props.category.id}`} className={`options-btn ${props.selected ? 'selected' : ''}`} onClick={(event) => { goToAnchor(event, props.category.id) }}>
      <div className='menu-product-image'>
        {props.category.image?.path && (
          <img className="category-img" src={props.category.image?.path} />
        )}
      </div>
      {getTrans(props.category, 'name', props.lang)}
    </a>
  </>
)

const Section = (props) => (
  <div>
    <h3 className="section" id={`section-${props.id}`}>
      <div className="section-title">{props.title.toUpperCase()}</div>
    </h3>
    {props.description && (
      <div className="section-description">
        {props.description}
      </div>
    )}
  </div>
)

const NoImageSVG = ({ t }) => (
  <div className="relative w-full h-32 bg-gray-100 flex items-center justify-center">
    <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
    <span className="absolute bottom-2 text-xs text-gray-500">{t('restaurant.photoSoon')}</span>
  </div>
)

const ClassificationImages = ({ classification }) => {
  return (
    <div className="flex flex-row">
      {classification && (classification.spicyLevel > 0 ?? false) && (
        <img
          key={'spicy'}
          alt="produit"
          className="w-6 h-6"
          src={ImageData[`spicy${classification.spicyLevel}`]}
        />
      )}
      {classification && (classification.isVegetarian ?? false) && (
        <img
          key={'vegetarian'}
          alt="produit"
          className="w-6 h-6"
          src={ImageData['vegetarian']}
        />
      )}
      {classification && (classification.isRecommended ?? false) && (
        <img
          key={'recommended'}
          alt="produit"
          className="w-6 h-6"
          src={ImageData[`recommended`]}
        />
      )}
      {classification && (classification.isHomemade ?? false) && (
        <img
          key={'homemade'}
          alt="produit"
          className="w-6 h-6"
          src={ImageData[`homemade`]}
        />
      )}
      {classification && (classification.isHalal ?? false) && (
        <img
          key={'halal'}
          alt="produit"
          className="w-6 h-6"
          src={ImageData[`halal`]}
        />
      )}
    </div>
  );
};



const ProductRow = (props) => {
  const { product, orderType, settings, t } = props
  const cartProducts = props.cartProducts ? props.cartProducts.filter(e => e.id === product.id) : [];
  const totalQuantity = cartProducts.length > 0 ? cartProducts.reduce((total, p) => total + p.quantity, 0) : 0;
  const price = formatCurrency(product.unitPrice, settings.currencySymbol)
  const unitPrice = parseFloat(product.unitPrice);

  let discountPrice = 0;
  let hasDiscount = false;
  let discountLabel = '';

  if (orderType === 1 && product.takeawayDiscount && product.takeawayDiscount.discount) {
    discountPrice = unitPrice * (1 - product.takeawayDiscount.discount / 100)
    hasDiscount = true;
    discountLabel = product.takeawayDiscount.discount
  }
  else if (orderType === 4 && product.deliveryDiscount && product.deliveryDiscount.discount) {
    discountPrice = unitPrice * (1 - product.deliveryDiscount.discount / 100)
    hasDiscount = true;
    discountLabel = product.deliveryDiscount.discount
  }
  else if ((orderType === 2 || orderType === 3) && product.tableDiscount && product.tableDiscount.discount) {
    discountPrice = unitPrice * (1 - product.tableDiscount.discount / 100)
    hasDiscount = true;
    discountLabel = product.tableDiscount.discount
  }

  const classification = product.classification ?? {}

  return (
    <div
      className={`relative w-40 sm:w-40 md:w-44 lg:w-48 xl:w-52 h-64 sm:h-68 md:h-72 lg:h-76 xl:h-80 bg-white rounded-lg border border-gray-200 overflow-hidden cursor-pointer transition-all duration-200 hover:border-blue-500 hover:shadow-md ${cartProducts.length > 0 ? 'ring-2 ring-blue-500 border-blue-500' : ''}`}
      onClick={props.toggleModal(product)}
    >
      {/* Product Image */}
      {product.image.path !== '' ? (
        <div className="relative w-full h-32">
          <img
            className="w-full h-full object-cover"
            src={convertFirebaseUrlToCustomDomain(product.image.path, props.cdnDomain)}
            alt={product.name}
          />
          {/* Classification logos positioned on image */}
          {classification && (
            <div className="absolute bottom-2 left-2">
              <ClassificationImages classification={classification} />
            </div>
          )}
        </div>
      ) : (
        <div className="relative w-full h-32">
          <NoImageSVG t={t} />
          {/* Classification logos positioned on placeholder */}
          {classification && (
            <div className="absolute bottom-2 left-2">
              <ClassificationImages classification={classification} />
            </div>
          )}
        </div>
      )}

      {/* Product Content */}
      <div className="p-2 flex flex-col gap-1 flex-1">

        {/* Product Name */}
        <h3 className="font-semibold text-base text-gray-900 leading-tight line-clamp-2">
          {getTrans(product, 'name', props.lang)}
        </h3>

        {/* Product Description */}
        {product.description !== "" && (
          <p className="text-gray-600 leading-[1.2] text-sm line-clamp-2">
            {getTrans(product, 'description', props.lang)}
          </p>
        )}
      </div>

      {/* Product Price - Absolutely Positioned */}
      <div className="absolute bottom-2 left-0 right-0 flex justify-center px-2">
        <div
          className="inline-block px-2 py-1 rounded-full"
          style={{
            backgroundColor: settings?.color ? `${settings.color}1A` : 'rgba(59, 130, 246, 0.1)'
          }}
        >
        {hasDiscount && (
          <div className={`${!product.canOrder ? 'text-red-500' : 'text-gray-900'}`}>
            <span className="line-through text-gray-500 text-sm">{formatCurrency(unitPrice, settings.currencySymbol)}</span>
            <span className="ml-1 font-semibold text-sm">{t('restaurant.discountPrice', { discount: discountLabel, price: formatCurrency(discountPrice, settings.currencySymbol) })}</span>
            {!product.canOrder && (
              <span className="block text-red-500 text-xs">{t('common.unavailable')}</span>
            )}
          </div>
        )}
        {!hasDiscount && product.unitPrice > 0 && (
          <div className={`font-semibold text-base ${!product.canOrder ? 'text-red-500' : 'text-gray-900'}`}>
            {price}
            {!product.canOrder && (
              <span className="block text-red-500 text-xs">{t('common.unavailable')}</span>
            )}
          </div>
        )}
        </div>
      </div>

      {/* Quantity Badge */}
      {cartProducts.length > 0 && (
        <div className="absolute top-2 right-2 bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-semibold">
          {totalQuantity}
        </div>
      )}
    </div>
  )
}
const MySwal = withReactContent(Swal)

const getResto = async (restoName) => {
  const docs = await firestore()
    .collection('Restaurant')
    .where('urlName', '==', restoName)
    .get();

  if (!docs.empty) {
    const data = {
      id: docs.docs[0].id,
      ...docs.docs[0].data(),
    }

    return data;
  }
  else {
    return null;
  }
}

class Restaurant extends Component<Props, State> {
  unsubscribe: Object
  refRestaurant: Object
  refProduct: Object
  refCategory: Object
  refDiscount: Object
  refOption: Object
  readOnly: boolean
  products: Array<Object>
  categories: Array<Object>
  discounts: Array<Object>
  options: Array<Object>
  selectCategory: Function

  constructor(props: Object) {
    super(props);

    this.unsubscribe = null
    this.refRestaurant = null
    this.refProduct = null
    this.refCategory = null
    this.refDiscount = null
    this.refOption = null

    this.readOnly = false
    this.allProducts = []
    this.availabilityTimer = null
    this.availabilityHours = null
    this._lastAvailabilityKey = null
    this.products = []
    this.categories = []
    this.discounts = []
    this.options = []
    this.recommendations = []

    this.state = {
      canOrder: false,
      settings: null,
      informations: null,
      showProductDetail: false,
      showRecommendation: false,
      restaurant: null,
      sections: [],
      selectedProduct: null,
      selectedRecommendation: null,
      invalidQrCode: false,
      selectedCategoryIdx: 0,
      selectedIdx: undefined,
      orderType: undefined,
      table: null,
      redirectToCart: false,
    }
  }

  componentDidMount() {
    const cartCreatedAt = new Date(this.props.cart.createdAt);
    if (this.props.cart.flushCart === true || isNaN(cartCreatedAt) || differenceInHours(new Date(), cartCreatedAt) >= 10) {
      this.props.resetCart();
      this.props.flushRecommendation();
    }
    const id = this.props.match.params.id

    if (id) {
      this.handleClickAndCollect()
    }
  }

  handleClickAndCollect = async () => {
    const restoName = this.props.match.params.id.toLowerCase()
    let orderType = this.props.cart.orderType === 1 || this.props.cart.orderType === 4 ? this.props.cart.orderType : 1;

    const type = this.props.match.params.orderType?.toLowerCase()
    if (type && type === 'emporter')
      orderType = 1
    if (type && type === 'livraison')
      orderType = 4
    if (type && type === 'kiosk')
      orderType = 2
    // shinzo menu pdf
    // if (restoName === 'shinzzo') {
    //   window.location.replace('https://we-eats.com/menu/shinzzo.pdf')
    // }
    const resto = await getResto(restoName)
    if (resto === null) {
      this.setState({ invalidQrCode: true })
      Swal.fire(this.props.t('restaurant.invalidQrTitle'), this.props.t('restaurant.invalidQrText'), "error");
      return
    }
    await this.initRestaurant(resto.id, resto)
    this.setState({ orderType: orderType })
    this.props.setDiscountSettings({ takeawayDiscount: { discount: this.props.settings.takeawaySettings.discount, discountFrom: this.props.settings.takeawaySettings.discountFrom }, deliveryDiscount: { discount: this.props.settings.deliverySettings.discount, discountFrom: this.props.settings.deliverySettings.discountFrom } })
    this.props.applyDiscount(orderType === 1 ? this.props.settings.takeawaySettings.discount || 0 : orderType === 4 ? this.props.settings.deliverySettings.discount || 0 : 0);
    this.props.updateType(orderType);
  }


  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe()
    if (this.unsubscribeProduct) this.unsubscribeProduct()
    if (this.unsubscribeCategory) this.unsubscribeCategory()
    if (this.availabilityTimer) clearInterval(this.availabilityTimer)
  }

  loadScript = () => {
    const header = $("#sticky-header");
    if (header.length) {
      window.onscroll = () => {
        handleActiveSection(header)
        handleStickyHeader(header)
      }
    }
  }

  initRestaurant = async (restoId, resto) => {
    // Determine if menu data should come from a secondary Firebase project
    let menuFirestore = firestore()
    let menuRestoId = restoId
    this.cdnDomain = null // null means use default CDN

    if (resto?.settings?.externalSource) {
      try {
        const secondaryFs = getSecondaryFirestore()
        const extDocs = await secondaryFs
          .collection('Restaurant')
          .where('urlName', '==', resto.settings.externalSource)
          .get()

        if (!extDocs.empty) {
          menuFirestore = secondaryFs
          menuRestoId = extDocs.docs[0].id
          this.cdnDomain = 'https://cdn2.we-eats.com'
        } else {
          console.warn(`externalSource "${resto.settings.externalSource}" not found in secondary project, falling back to primary`)
        }
      } catch (err) {
        console.warn('Failed to initialize secondary Firebase, falling back to primary:', err)
      }
    }

    // Settings, discounts always from primary
    this.refRestaurant = firestore().collection('Restaurant').doc(restoId)
    this.refDiscount = firestore().collection(`Restaurant/${restoId}/Discount`)

    // Menu data (products, categories, options, recommendations) from resolved source
    this.refProduct = menuFirestore.collection(`Restaurant/${menuRestoId}/Product`)
    this.refOption = menuFirestore.collection(`Restaurant/${menuRestoId}/Rubric`)
    this.refCategory = menuFirestore.collection(`Restaurant/${menuRestoId}/Category`).where('status', '==', 1)
    this.refRecommendation = menuFirestore.collection(`Restaurant/${menuRestoId}/Recommendation`)

    this.unsubscribe = this.refRestaurant.onSnapshot(this.onRestoUpdate)
    this.unsubscribeProduct = this.refProduct.onSnapshot(this.onProductUpdate)
    this.unsubscribeCategory = this.refCategory.onSnapshot(this.onCategoryUpdate)

    // Re-check product availability every 60 seconds for time-based filtering.
    // checkProductWithAvailability short-circuits when no day/period boundary has been crossed.
    this.availabilityTimer = setInterval(this.checkProductWithAvailability, 60000)

    const productP = this.refProduct.get()
    const categoryP = this.refCategory.get()
    const discountP = this.refDiscount.get()
    const optionP = this.refOption.get()
    const recoP = this.refRecommendation.get()

    Promise.all([productP, categoryP, discountP, optionP, recoP])
      .then(([product, category, discount, option, reco]) => {
        const products = []
        const categories = []
        const discounts = []
        const options = []
        const recos = []

        const allProducts = []
        product.forEach((doc) => {
          const { createdAt, ...data } = doc.data()
          allProducts.push({ id: doc.id, ...data });
        });
        this.allProducts = allProducts
        products.push(...this.filterProducts(allProducts))
        category.forEach((doc) => {
          const { createdAt, ...data } = doc.data()
          if (!data.internal && (data.displayApp || data.displayApp === undefined)) categories.push({ id: doc.id, ...data })
        });
        discount.forEach((doc) => {
          const { createdAt, ...data } = doc.data()
          discounts.push({ id: doc.id, ...data })
        });
        option.forEach((doc) => {
          const { id, products, shared, ...data } = doc.data()
          options.push({ id: doc.id, ...data })
        })
        reco.forEach((doc) => {
          recos.push({
            id: doc.id,
            ...doc.data(),
          });
        })
        this.products = products
        this.categories = categories.sort((a, b) => (a.index < b.index ? -1 : 1))
        this.discounts = discounts
        this.options = options
        this.recommendations = recos
        this.getSections()
        return true
      })
      .catch(err => {
        console.log(err)
        return false
      })
  }

  onRestoUpdate = (querySnapshot: Object) => {
    const restaurant = querySnapshot.data()
    const orderSchedule = parseSchedule(restaurant.settings.orderSchedule);
    const deliverySchedule = parseSchedule(restaurant.settings.deliverySchedule);

    const deliverySettings = restaurant.deliverySettings || {};
    const takeawaySettings = restaurant.takeawaySettings || {};

    this.props.updateRestoInfo(restaurant.informations.id, restaurant.informations.name, restaurant.informations.postalCode, restaurant.state.canOrder, restaurant.informations, restaurant.state.canOrderDelivery);
    this.props.updateRestoSettings(restaurant.informations.id, restaurant.settings.color, restaurant.settings.autoAcceptOrder, restaurant.settings.delivery, restaurant.settings.takeaway, restaurant.settings.table, restaurant.settings.stripe || '', restaurant.settings.orderTypePopup || false, restaurant.settings.sharedCart || false, restaurant.settings.currencySymbol || '€', restaurant.settings.showCurrencyOnOrder !== false);
    this.props.updateMenuSettings({ productComments: restaurant.settings.productComments, languages: restaurant.settings.languages });
    // Langue choisie non activée par le restaurant : retour au français
    if (!getActiveLanguages(restaurant.settings).includes(this.props.settings.lang)) {
      this.props.setLanguage(DEFAULT_LANG)
    }
    this.props.updateDeliverySchedule(deliverySchedule);
    this.props.updateOrderSchedule(orderSchedule);
    this.props.updateDeliverySettings(deliverySettings);
    this.props.updateTakeawaySettings(takeawaySettings);
    this.availabilityHours = restaurant.settings?.availabilityHours ?? null
    this._lastAvailabilityKey = null
    this.checkProductWithAvailability()
    this.props.updateColors(restaurant.settings.useDarkTheme)

    // if (!restaurant.settings.delivery && restaurant.settings.takeaway === true) {
    //   this.handleOrderTypeChange(1)
    // }
    // if (restaurant.settings.delivery === true && !restaurant.settings.takeaway) {
    //   this.handleOrderTypeChange(4)
    // }
    if (!restaurant.settings.delivery && !restaurant.settings.takeaway && !restaurant.settings.table) {
      this.handleOrderTypeChange(0)
      this.readOnly = true
    }


    analytics().logEvent('home_page', { restoId: restaurant.informations.id, restoName: restaurant.informations.name });


    setTimeout(() => {
      this.setState({
        settings: restaurant.settings,
        informations: restaurant.informations,
        restaurant: restaurant,
        canOrder: this.state.orderType === 4 ? (restaurant.state.canOrderDelivery ?? true) : (restaurant.state.canOrder ?? true)
      })
      this.loadScript()

      if (this.state.orderType === 2 || this.state.orderType === 3) return

      if (restaurant.settings.orderTypePopup !== undefined && restaurant.settings.orderTypePopup && restaurant.settings.takeaway === true && restaurant.settings.delivery === true && this.props.cart.pickedOrderType === false) {
        MySwal.fire({
          title: <p>{this.props.t('restaurant.orderTypePopupTitle')}</p>,
          confirmButtonText: <div><RiShoppingBagLine size="1.0em" /> {this.props.t('restaurant.orderTypePopupTakeaway')}</div>,
          cancelButtonText: <div><RiEBike2Line size="1.0em" /> {this.props.t('restaurant.orderTypePopupDelivery')}</div>,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#3085d6',
          showCancelButton: true,
          allowOutsideClick: false
        }).then((result) => {
          if (result.isConfirmed) {
            this.handleOrderTypeChange(1)
          } else {
            this.handleOrderTypeChange(4)
          }
          this.props.pickedOrderType()
        })
      }

    }, 1000)
  }

  onProductUpdate = (querySnapshot: Object) => {
    const allProducts = []
    querySnapshot.forEach((doc) => {
      const { createdAt, ...data } = doc.data()
      allProducts.push({ id: doc.id, ...data });
    });
    this.allProducts = allProducts
    this.products = this.filterProducts(allProducts)
    this.getSections()
  }

  /**
   * Visibilité d'un produit : type de commande (display / displayApp) puis disponibilité
   * horaire (créneaux midi/soir par jour, jours fériés) — même filtre que we-kiosk-order.
   */
  filterProducts = (list: Array<Object>, orderType: number = this.state.orderType) => {
    const typeKey = orderType === 1 ? 'takeaway' : (orderType === 4 ? 'delivery' : null);
    const isPublicHoliday = isPublicHolidayToday()
    const period = getAvailabilityPeriod(this.availabilityHours, dayjs().day(), isPublicHoliday)
    return list.filter((p) => {
      // Combine conditions and add to products if conditions are met
      const visible = (p.display?.[typeKey] === true) || (p.display?.[typeKey] === undefined && (p.displayApp || p.displayApp === undefined))
      return visible && isProductAvailable(p, period, isPublicHoliday)
    })
  }

  // Re-filtre les produits quand on change de jour ou de service (midi/soir) ;
  // court-circuite tant qu'aucune frontière n'a été franchie.
  checkProductWithAvailability = () => {
    if (this.allProducts.length === 0) return
    const isPublicHoliday = isPublicHolidayToday()
    const { isDayTime, serviceDay } = getAvailabilityPeriod(this.availabilityHours, dayjs().day(), isPublicHoliday)
    const key = `${isPublicHoliday ? 1 : 0}|${serviceDay}|${isDayTime ? 1 : 0}`
    if (key === this._lastAvailabilityKey) return
    this._lastAvailabilityKey = key
    this.products = this.filterProducts(this.allProducts)
    this.getSections()
  }

  onCategoryUpdate = (querySnapshot: Object) => {
    const categories = []
    querySnapshot.forEach((doc) => {
      const { createdAt, ...data } = doc.data()
      if (!data.internal && (data.displayApp || data.displayApp === undefined)) categories.push({ id: doc.id, ...data })
    })
    this.categories = categories.sort((a, b) => (a.index < b.index ? -1 : 1))
    this.getSections()
  }

  handleQrCode = async (data: string) => {
    if ((data.length !== 20 && data.length !== 41) || (data.length === 41 && data[20] !== '-'))
      return null
    if (data.length === 20) {
      const restoId = data
      const ref = firestore().collection('Restaurant').doc(restoId)
      return await ref.get()
        .then(doc => {
          if (doc.exists) {
            return restoId
          } else {
            return null
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
    else if (data.length === 41) {
      const restoId = data.split('-')[0]
      const tableId = data.split('-')[1]

      const ref = firestore().collection(`Restaurant/${restoId}/QRCode`).doc(tableId)
      return await ref.get()
        .then(doc => {
          if (doc.exists) {
            const orderType = 3
            this.props.setDiscountSettings({ takeawayDiscount: { discount: this.props.settings.takeawaySettings.discount, discountFrom: this.props.settings.takeawaySettings.discountFrom }, deliveryDiscount: { discount: this.props.settings.deliverySettings.discount, discountFrom: this.props.settings.deliverySettings.discountFrom } })
            this.props.applyDiscount(orderType === 1 ? this.props.settings.takeawaySettings.discount || 0 : orderType === 4 ? this.props.settings.deliverySettings.discount || 0 : 0);
            this.props.updateType(orderType);
            return restoId
          } else {
            return null
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }

  toggleModal = (product) => () => {
    const canOrderProduct = this.state.orderType === 4 ? (product.canOrderDelivery ?? true) : (product.canOrder ?? true);
    if (canOrderProduct)
      this.setState(prevState => ({
        selectedProduct: { ...product },
        showProductDetail: !prevState.showProductDetail,
        selectedIdx: undefined
      }))
  }

  closeProductModal = () => {
    this.setState({ showProductDetail: false })
  }

  openRecommendation = async () => {
    if (this.props.recommendation.hasRefused || this.props.recommendation.count >= 2) {
      return;
    }

    const { recommendation1, recommendation2 } = this.props.recommendation;

    if (recommendation1 === null || (recommendation1 === true && recommendation2 === null)) {
      const recoDocs = await this.refRecommendation.where('targetProducts', 'array-contains', this.state.selectedProduct.id).get();

      if (recoDocs.docs.length > 0) {
        const reco = recoDocs.docs[0].data();
        const { total, totalProducts } = this.props.cart;
        if (total >= reco.minOrder && totalProducts >= reco.minProducts)
          this.setState({ showRecommendation: true, selectedRecommendation: reco });
      }
    }
  }

  closeProductRecommendation = (hasRefused) => {
    if (hasRefused) {
      this.props.setHasRefusedRecommendation();
    } else {
      this.props.incrementRecommendationCount();
    }

    this.setState({ showRecommendation: false, selectedRecommendation: null })
  }

  goToCart = async () => {
    const cartReco = await this.refRecommendation.doc('1').get()
    if (cartReco.exists) {
      const { total, totalProducts } = this.props.cart;
      const reco = cartReco.data();
      if (total >= reco.minOrder && totalProducts >= reco.minProducts) {
        this.setState({
          showRecommendation: true,
          selectedRecommendation: reco,
        })
      }
    }
    this.setState({
      redirectToCart: true,
    });
  }

  getSections = () => {
    const sections = []
    for (let i = 0; i < this.categories.length; i++) {
      const products = this.products.filter((item) => item.categoryId === this.categories[i].id).sort(((a, b) => (a.index < b.index ? -1 : 1)))
      if (products.length === 0) {
        this.categories[i].displayApp = false
        continue
      }
      sections.push({
        title: this.categories[i].name,
        description: this.categories[i].description,
        category: this.categories[i],
        categoryMaxQuantity: this.categories[i].maxQuantity || 0,
        data: products,
        index: i,
        id: this.categories[i].id
      })
    }
    this.setState({ sections })
  }


  onClickCartProduct = (index) => e => {
    this.setState({
      selectedProduct: this.props.cart.products[index],
      showProductDetail: true,
      selectedIdx: index

    });
  };

  handleOrderTypeChange = (orderType) => {
    const { restaurant } = this.state;
    const canOrder = orderType === 4 ? (restaurant?.state?.canOrderDelivery ?? true) : (restaurant?.state?.canOrder ?? true);
    this.setState({ orderType, canOrder });
    this.props.setDiscountSettings({ takeawayDiscount: { discount: this.props.settings.takeawaySettings.discount, discountFrom: this.props.settings.takeawaySettings.discountFrom }, deliveryDiscount: { discount: this.props.settings.deliverySettings.discount, discountFrom: this.props.settings.deliverySettings.discountFrom } })
    this.props.applyDiscount(orderType === 1 ? this.props.settings.takeawaySettings.discount || 0 : orderType === 4 ? this.props.settings.deliverySettings.discount || 0 : 0);
    this.props.updateType(orderType);
    this.products = this.filterProducts(this.allProducts, orderType)
    this.getSections()

  }

  getOrderTotal = () => {
    let total = this.props.cart.total;
    if (this.props.cart.coupon !== null) {
      if (this.props.cart.coupon?.discountType === 'percent') {
        total = Number.parseFloat(computeDiscount(total, this.props.cart.coupon.discountPercent, true).toFixed(2));
      }
      else if (this.props.cart.coupon?.discountType === 'price') {
        total -= this.props.cart.coupon.discountPrice;
      }
    }
    return total;
  }

  removeCoupon = () => {
    this.props.applyCoupon(null);
  }

  render() {
    if (this.state.invalidQrCode) {
      const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData404.default,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      }
      return (
        <div id="not-found">
          <Breakpoint medium up>
            <Lottie
              options={defaultOptions}
            />
          </Breakpoint>
          <Breakpoint small down>
            <Lottie
              options={defaultOptions}
            />
          </Breakpoint>
        </div>
      )
    }
    if (!this.state.informations) {
      const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData.default,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      }

      return (
        <div className="center-loading">
          <Breakpoint medium up>
            <Lottie
              options={defaultOptions}
            />
          </Breakpoint>
          <Breakpoint small down>
            <Lottie
              options={defaultOptions}
            />
          </Breakpoint>
        </div>
      )
    }
    const { t } = this.props
    const now = new Date();
    const dayOfTheWeek = now.getDay() ? now.getDay() - 1 : 6;
    let checkoutLink = `/${this.props.match.params.id}/cart`
    const lang = this.props.settings.lang || DEFAULT_LANG
    const activeLanguages = getActiveLanguages(this.props.settings)

    if (this.state.redirectToCart && !this.state.showProductDetail && !this.state.showRecommendation) {
      return (
        <Redirect
          to={checkoutLink}
        />
      )
    }

    return (
      <Container className="container" id="main" >
        {
          this.props.settings.color && (
            <style> {`body {
              --website-color: ${this.props.settings.color}
            }`}
            </style>
          )
        }
        {
          this.props.colors && (
            <style> {`body {
              --colors-mainBg: ${this.props.colors.mainBg};
              --colors-main: ${this.props.colors.main};
              --colors-mainText: ${this.props.colors.mainText};
              --colors-categoryBg: ${this.props.colors.categoryBg};
              --colors-categoryBtnSelected: ${this.props.colors.categoryBtnSelected};
              --colors-categoryText: ${this.props.colors.categoryText};
              --colors-categoryTextSelected: ${this.props.colors.categoryTextSelected};
              --colors-productBg: ${this.props.colors.productBg};
              --colors-imgBorder: ${this.props.colors.imgBorder};
              --colors-categoryName: ${this.props.colors.categoryName};
              --colors-productBtn: ${this.props.colors.productBtn};
              --colors-productName: ${this.props.colors.productName};
              --colors-productDescription: ${this.props.colors.productDescription};
              --colors-productBorder: ${this.props.colors.productBorder};
              --colors-productPrice: ${this.props.colors.productPrice};
            }`}
            </style>
          )
        }
        <div className="header">

          <div className="header-image">
            {this.state.restaurant.photos.profilPath && (
              <img
                className="restaurant-img"
                src={convertFirebaseUrlToCustomDomain(this.state.restaurant.photos.profilPath)}
                alt="restaurant-logo"
              />
            )}
          </div>

          <div className="restaurant-info">
            <div className={`restaurant-title-row centered ${activeLanguages.length > 1 ? 'has-lang' : ''}`}>
              <div className="restaurant-name">
                {this.state.informations.name}
              </div>
              <LanguageSelector activeLanguages={activeLanguages} lang={lang} onChange={this.props.setLanguage} t={t} />
            </div>

            {(this.state.orderType === 1 || this.state.orderType === 4) && (
              <>
                <div className="restaurant-info-text">
                  {getBusinessTypes(this.state.informations.businessType)}
                </div>

                <div className="restaurant-info-text">
                  <em>{this.state.informations.address} {this.state.informations.postalCode} {this.state.informations.city}</em>
                </div>

                <hr className="message-separator" />
              </>
            )}


            {!this.readOnly && (this.state.orderType === 1 || this.state.orderType === 4) && (
              <div className="restaurant-info-text bullet">

                {this.state.orderType === 1 && (
                  <span>{t('restaurant.prepTime', { minutes: this.props.settings.takeawaySettings.prepTime || 15 })}</span>
                )}

                {this.state.orderType === 4 && (
                  <span>{t('restaurant.deliveryTime', { minutes: this.props.settings.deliverySettings.deliveryTime || 15 })}</span>
                )}
              </div>
            )}

            {this.state.orderType === 1 && this.props.settings.takeawaySettings.customMessage ? (
              <div className="restaurant-info-text bullet">
                {this.props.settings.takeawaySettings.customMessage}
              </div>
            ) : this.state.orderType === 4 && this.props.settings.deliverySettings.customMessage ? (
              <div className="restaurant-info-text bullet">
                {this.props.settings.deliverySettings.customMessage}
              </div>
            ) : null}


            <Breakpoint small down>
              {this.props.settings.takeaway === true && this.props.settings.delivery === true && this.props.cart.orderType !== 2 && (this.props.settings.orderTypePopup === undefined || this.props.settings.orderTypePopup === false) && (
                <div className="cart-product-container">
                  <div className="cart-title">{t('restaurant.orderTypeTitle')}</div>
                  <div className="order-type-pick">
                    {this.props.settings.orderSchedule && (this.props.settings.orderSchedule[now.getDay()].length > 0 || this.props.settings.orderSchedule[dayOfTheWeek].length > 0) ? (
                      <div
                        onClick={() => this.handleOrderTypeChange(1)}
                        className={`order-type-choice ${this.state.orderType === 1 ? 'selected' : ''}`}
                      >
                        {getOrderType(1)}
                        {this.state.orderType === 1 && (
                          <FaCheckCircle size="1.5em" style={{ position: 'absolute', top: '-8px', right: '-4px' }} className="main-color" />
                        )}
                      </div>
                    ) : (
                      <div
                        className={`order-type-choice disabled`}
                      >
                        {getOrderType(1)}
                        {this.state.orderType === 1 && (
                          <FaCheckCircle size="1.5em" style={{ position: 'absolute', top: '-8px', right: '-4px' }} className="main-color" />
                        )}
                      </div>
                    )}


                    {this.props.settings.deliverySchedule && (this.props.settings.deliverySchedule[now.getDay()].length > 0 || this.props.settings.deliverySchedule[dayOfTheWeek].length > 0) ? (
                      <div
                        onClick={() => this.handleOrderTypeChange(4)}
                        className={`order-type-choice ${this.state.orderType === 4 ? 'selected' : ''}`}
                      >
                        {getOrderType(4)}
                        {this.state.orderType === 4 && (
                          <FaCheckCircle size="1.5em" style={{ position: 'absolute', top: '-8px', right: '-4px' }} className="main-color" />
                        )}
                      </div>
                    ) : (
                      <div className={`order-type-choice disabled`}>
                        {getOrderType(4)}
                        {this.state.orderType === 4 && (
                          <FaCheckCircle size="1.5em" style={{ position: 'absolute', top: '-8px', right: '-4px' }} className="main-color" />
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </Breakpoint>
          </div>
        </div>

        <div className="category-container" id="sticky-header">

          <div className="options">
            {this.categories.map((category, idx) =>
              <CategoryRow
                category={category}
                key={category.id}
                lang={lang}
                idx={idx}
                selected={idx === this.state.selectedCategoryIdx}
                selectCategory={this.selectCategory}
              />
            )}
          </div>
        </div>


        {this.props.match.params.id === 'shinzzo' && (
          <Masonry
            breakpointCols={breakpointColumnsObj}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column"
          >
            {this.categories.map((category, idx) =>
              <div>
                <CategoryLogo
                  category={category}
                  key={category.id}
                  lang={lang}
                  idx={idx}
                  selected={idx === this.state.selectedCategoryIdx}
                  selectCategory={this.selectCategory}
                />
              </div>
            )}
          </Masonry>
        )}


        <Breakpoint medium up>
          <div className="product-grid">
            <div className="product-container">
              {this.state.sections.map((section, index) => (
                <div key={index}>
                  <Section title={getTrans(section.category, 'name', lang) || section.title} id={section.id} description={getTrans(section.category, 'description', lang)} />
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 p-4 justify-items-center">
                    {section.data.map((product) =>
                      <ProductRow
                        cartProducts={this.props.cart.products}
                        product={product}
                        key={product.id}
                        toggleModal={this.toggleModal}
                        orderType={this.props.cart.orderType}
                        settings={this.props.settings}
                        cdnDomain={this.cdnDomain}
                        lang={lang}
                        t={t}
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
            {/* {this.readOnly === false && ( */}
            <div className="cart">
              {this.props.settings.takeaway === true && this.props.settings.delivery === true && this.props.cart.orderType !== 2 && (this.props.settings.orderTypePopup === undefined || this.props.settings.orderTypePopup === false) && (
                <div className="cart-product-container">
                  <div className="cart-title">{t('restaurant.orderTypeTitle')}</div>
                  <div className="order-type-pick">
                    {this.props.settings.orderSchedule && (this.props.settings.orderSchedule[now.getDay()].length > 0 || this.props.settings.orderSchedule[dayOfTheWeek].length > 0) ? (
                      <div
                        onClick={() => this.handleOrderTypeChange(1)}
                        className={`order-type-choice ${this.state.orderType === 1 ? 'selected' : ''}`}
                      >
                        {getOrderType(1)}
                        {this.state.orderType === 1 && (
                          <FaCheckCircle size="1.5em" style={{ position: 'absolute', top: '-8px', right: '-4px' }} className="main-color" />
                        )}
                      </div>
                    ) : (
                      <div className={`order-type-choice disabled`}>
                        {getOrderType(1)}
                        {this.state.orderType === 1 && (
                          <FaCheckCircle size="1.5em" style={{ position: 'absolute', top: '-8px', right: '-4px' }} className="main-color" />
                        )}
                      </div>
                    )}


                    {this.props.settings.deliverySchedule && (this.props.settings.deliverySchedule[now.getDay()].length > 0 || this.props.settings.deliverySchedule[dayOfTheWeek].length > 0) ? (
                      <div
                        onClick={() => this.handleOrderTypeChange(4)}
                        className={`order-type-choice ${this.state.orderType === 4 ? 'selected' : ''}`}
                      >
                        {getOrderType(4)}
                        {this.state.orderType === 4 && (
                          <FaCheckCircle size="1.5em" style={{ position: 'absolute', top: '-8px', right: '-4px' }} className="main-color" />
                        )}
                      </div>
                    ) : (
                      <div className={`order-type-choice disabled`}>
                        {getOrderType(4)}
                        {this.state.orderType === 1 && (
                          <FaCheckCircle size="1.5em" style={{ position: 'absolute', top: '-8px', right: '-4px' }} className="main-color" />
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}
              {/* Desktop cart sidebar */}
              <div className="cart-title rounded-lg">{t('modalCart.title')}</div>
              {this.state.canOrder === true && (
                <div className="cart-content">
                  {this.props.cart.products.map((product, index) =>
                    <ProductCartRow
                      product={product}
                      key={index}
                      index={index}
                      onClick={this.onClickCartProduct}
                    // cart={this.props.cart}
                    />
                  )}
                </div>
              )}

              {!this.state.canOrder ? (
                <div><em>{t('restaurant.orderSuspended')}</em></div>
              ) : this.props.cart.products.length === 0 ? (
                <div><em>{t('restaurant.emptyOrder')}</em></div>
              ) : (
                <div className="cart-bottom">
                  {this.props.cart.discount > 0 && (
                    <div className="cart-product-item discount-row">
                      <div className="cart-product-row" style={{ cursor: 'unset' }}>
                        <div>{t('restaurant.subtotal')}</div>
                        <div>{formatCurrency(this.props.cart.subtotal, this.props.settings.currencySymbol)}</div>
                      </div>
                    </div>
                  )}

                  {this.props.cart.discount > 0 && this.props.cart.subtotal !== this.props.cart.total && (
                    <div className="cart-product-item discount-row">
                      <div className="cart-product-row" style={{ cursor: 'unset' }}>
                        <div>{t(this.state.orderType === 1 ? 'restaurant.discountTakeaway' : this.state.orderType === 4 ? 'restaurant.discountDelivery' : 'restaurant.discount', { discount: this.props.cart.discount })}</div>
                        <div>-{formatCurrency(this.props.cart.subtotal - this.props.cart.total, this.props.settings.currencySymbol)}</div>
                      </div>
                    </div>
                  )}

                  {this.props.cart.coupon !== null ? this.props.cart.coupon?.discountType === 'percent' ? (
                    <div className="cart-product-item discount-row">
                      <div className={`cart-row`} style={{ width: '100%', justifyContent: 'space-between' }}>
                        <div>
                          <span className="remove-coupon-button" onClick={this.removeCoupon}>X</span>
                          {t('restaurant.couponPercent', { percent: this.props.cart.coupon.discountPercent })}
                        </div>
                        <div>-{formatCurrency(computeDiscount(this.props.cart.total, this.props.cart.coupon.discountPercent, false), this.props.settings.currencySymbol)}</div>
                      </div>
                    </div>
                  ) : this.props.cart.coupon?.discountType === 'price' ? (
                    <div className="cart-product-item discount-row">
                      <div className={`cart-row`} style={{ width: '100%', justifyContent: 'space-between' }}>
                        <div>
                          <span className="remove-coupon-button" onClick={this.removeCoupon}>X</span>
                          {t('restaurant.couponPrice', { price: formatCurrency(this.props.cart.coupon.discountPrice, this.props.settings.currencySymbol) })}
                        </div>
                        <div>-{formatCurrency(this.props.cart.total - this.props.cart.coupon.discountPrice, this.props.settings.currencySymbol)}</div>
                      </div>
                    </div>
                  ) : this.props.cart.coupon?.discountType === 'product' ? (
                    <div className="cart-product-item discount-row">
                      <div className={`cart-row`} style={{ width: '100%', justifyContent: 'space-between' }}>
                        <div>
                          <span className="remove-coupon-button" onClick={this.removeCoupon}>X</span>
                          {t('restaurant.couponProduct', { product: this.props.cart.coupon.discountProduct })}
                        </div>
                        <div></div>
                      </div>
                    </div>
                  ) : null : null}

                  <div className="footer-desktop" onClick={this.goToCart}>
                    <div className="confirm-btn rounded-lg">
                      <span>{this.props.cart.totalProducts}</span>
                      <span>{t('modalCart.title')}</span>
                      <span>{formatCurrency(this.getOrderTotal(), this.props.settings.currencySymbol)}</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* )} */}

          </div>
        </Breakpoint>

        <Breakpoint small down>
          <div className="product-grid">
            <div className="product-container">
              {this.state.sections.map((section, index) => (
                <div className="section-container" key={index}>
                  <Section title={getTrans(section.category, 'name', lang) || section.title} id={section.id} description={getTrans(section.category, 'description', lang)} />
                  <div className="grid grid-cols-2 gap-3 p-2 justify-items-center">
                    {section.data.map((product) =>
                      <ProductRow
                        cartProducts={this.props.cart.products}
                        product={product}
                        key={product.id}
                        toggleModal={this.toggleModal}
                        orderType={this.props.cart.orderType}
                        settings={this.props.settings}
                        cdnDomain={this.cdnDomain}
                        lang={lang}
                        t={t}
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {this.readOnly === false && !this.state.canOrder ? (
            <Link className="footer">
              <div className="confirm-btn"><em>{t('restaurant.orderDisabled')}</em></div>
            </Link>
          ) : this.readOnly === false && this.props.cart.products.length > 0 ? (
            <div className="footer" onClick={this.goToCart}>
              <div className="confirm-btn">
                <span>{this.props.cart.totalProducts}</span>
                <span>{t('modalCart.title')}</span>
                <span>{formatCurrency(this.props.cart.total, this.props.settings.currencySymbol)}</span>
              </div>
            </div>
          ) : null}

        </Breakpoint>

        <FooterBar orderType={this.state.orderType} />

        <Modal
          show={this.state.showProductDetail}
          className="custom-map-modal"
          aria-labelledby="example-custom-modal-styling-title"
          onHide={this.closeProductModal}
          size="md"
          animation
          centered
        >
          <ProductDetail
            cart={this.props.cart}
            product={this.state.selectedProduct}
            closeModal={this.closeProductModal}
            openRecommendation={this.openRecommendation}
            updateIndex={this.state.selectedIdx}
            options={this.options}
            readOnly={this.readOnly}
            canOrder={this.state.canOrder}
            cdnDomain={this.cdnDomain}
          />
        </Modal>

        <Modal
          show={this.state.showRecommendation}
          onHide={() => this.closeProductRecommendation(true)}
          centered
          size="md"
          className="custom-map-modal"
          dialogClassName="w-full"
        >
          <ProductRecommendation
            products={this.allProducts}
            recommendation={this.state.selectedRecommendation}
            showProduct={this.toggleModal}
            close={this.closeProductRecommendation}
            cdnDomain={this.cdnDomain}
          />
        </Modal>

      </Container >
    )
  }
}

// redux

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    settings: state.settings,
    recommendation: state.recommendation,
    colors: state.colors
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateColors: (useDarkTheme) => dispatch(updateColors(useDarkTheme)),
    updateRestoInfo: (a, b, c, d, e, f) => dispatch(updateRestoInfo(a, b, c, d, e, f)),
    updateRestoSettings: (a, b, c, d, e, f, g, h, i, j) => dispatch(updateRestoSettings(a, b, c, d, e, f, g, h, i, j)),
    updateMenuSettings: (s) => dispatch(updateMenuSettings(s)),
    setLanguage: (lang) => dispatch(setLanguage(lang)),
    updateType: (type) => dispatch(updateType(type)),
    applyDiscount: (d) => dispatch(applyDiscount(d)),
    updateOrderSchedule: (schedule) => dispatch(updateOrderSchedule(schedule)),
    updateDeliverySchedule: (schedule) => dispatch(updateDeliverySchedule(schedule)),
    updateDeliverySettings: (s) => dispatch(updateDeliverySettings(s)),
    updateTakeawaySettings: (s) => dispatch(updateTakeawaySettings(s)),
    resetCart: () => dispatch(resetCart()),
    applyCoupon: (coupon) => dispatch(applyCoupon(coupon)),
    pickedOrderType: () => dispatch(pickedOrderType()),
    setDiscountSettings: (settings) => dispatch(setDiscountSettings(settings)),
    setHasRefusedRecommendation: () => dispatch(setHasRefused()),
    incrementRecommendationCount: () => dispatch(incrementRecommendationCount()),
    setRecommendation1: (s) => dispatch(setRecommendation1(s)),
    setRecommendation2: (s) => dispatch(setRecommendation2(s)),
    flushRecommendation: (s) => dispatch(flushRecommendations(s)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Restaurant));
